import { FC } from 'react';
import { formatNumberDecimals } from 'utils/formats';

import { useGetUsufructuariesTooltipText } from 'modules/partners/hooks/useGetUsufructuariesTooltipText';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import { DividendData } from '../types/DividendData';

type DividendsTableRowProps = {
  index: number;
  dividend: DividendData;
};

const DividendsTableRow: FC<DividendsTableRowProps> = ({ index, dividend }) => {
  const { data } = useDividendsDistributionModal();

  const {
    data: { tooltipText },
  } = useGetUsufructuariesTooltipText({
    usufructData: dividend.usufructData,
  });

  return (
    <>
      <td className="tb-tnx-info" key={`name-${index}`}>
        <div className="tb-tnx-info w-150px d-flex align-items-center">
          <span className="title">{dividend.name}</span>
          {tooltipText && (
            <IconTooltip id={`usufruct-info-${index}`} tooltip={tooltipText} />
          )}
        </div>
      </td>

      <td className="tb-tnx-item" key={`ndPercent-${index}`}>
        <span className="tb-tnx-total text-right w-100">
          {formatNumberDecimals(dividend.ndPercent)}%
        </span>
      </td>

      {data.hasRetention && (
        <td className="tb-tnx-item">
          <span
            className="tb-tnx-total text-right w-100"
            key={`dividendAmount-${index}`}
          >
            {formatNumberDecimals(dividend.dividendAmount)}€
          </span>
        </td>
      )}

      <td className="tb-tnx-item">
        <span
          className="tb-tnx-total text-right w-100"
          key={`toPerceive-${index}`}
        >
          {formatNumberDecimals(
            dividend.dividendAmount - dividend.retentionAmount
          )}
          €
        </span>
      </td>
    </>
  );
};

export default DividendsTableRow;
